import { ComponentProps, forwardRef } from 'react'

import { Related, RelatedLayout } from '@karakuri-web/faq-type'

import { QAContent, QAHeader, QAPanel } from '../components'
import { useFaqRouting } from '../contexts/FaqRoutingContext'

interface Props {
  related: Related[]
  layout: RelatedLayout
}

/**
 * 関連FAQ ウィジェット
 * 関連するFAQを表示する
 */
export function RelatedWidget({ related, layout }: Props) {
  const { Link } = useFaqRouting()

  return related.length > 0 ? (
    <QAPanel>
      <QAHeader title={layout.title || '関連するよくあるご質問'} />
      {related.map(({ id, title }) => {
        const LinkComponent = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(
          function LinkComponent(props, ref) {
            return <Link ref={ref} {...props} to={`/answer/${id}/`} />
          }
        )
        return <QAContent key={id} question={title} LinkComponent={LinkComponent} />
      })}
    </QAPanel>
  ) : null
}
